var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-operation-province"},[_c('div',{staticClass:"project-item alone"},[_c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.province)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }